export default __webpack_public_path__ + "static/media/flag-poland.c0e41cad.svg";